// Copy of the backend's well-known products; import `WellKnownProductId` once a types__api release has it (gymware#1230, projects#950).
export enum CashDifferenceProductId {
    surplus = '00000000-ffff-0000-0000-000ca5500003',
    shortage = '00000000-ffff-0000-0000-000ca5500013',
}
